import { forwardRef } from 'react';

import { ActionIcon } from '@mantine/core';
import { IconDots } from '@tabler/icons-react';

import type { RowMenuTriggerViewProps } from './RowMenuTrigger.types';

export const RowMenuTriggerView = forwardRef<HTMLButtonElement, RowMenuTriggerViewProps>(
  function RowMenuTriggerView(
    { variant = 'subtle', size = 'md', color = 'gray', label, ...rest },
    ref
  ) {
    return (
      <ActionIcon
        ref={ref}
        variant={variant}
        color={color}
        size={size}
        aria-label={label}
        {...rest}
      >
        <IconDots size={16} />
      </ActionIcon>
    );
  }
);
